module.exports = __webpack_public_path__ + "static/media/bg_22.7280dfb8.png";